import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-f41533b8")

_pushScopeId("data-v-f41533b8")
const _hoisted_1 = {
  key: 1,
  class: "el-form-item__error"
}
const _hoisted_2 = {
  key: 1,
  class: "el-form-item__error"
}
const _hoisted_3 = { class: "dialog-footer" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_cus_option = _resolveComponent("cus-option")
  const _component_cus_select = _resolveComponent("cus-select")
  const _component_el_switch = _resolveComponent("el-switch")
  const _component_el_radio = _resolveComponent("el-radio")
  const _component_feature_plan_select = _resolveComponent("feature-plan-select")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_button = _resolveComponent("el-button")
  const _component_dialog_shell = _resolveComponent("dialog-shell")
  const _component_update_billing_list = _resolveComponent("update-billing-list")
  const _component_edit_feature_plan_dialog = _resolveComponent("edit-feature-plan-dialog")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode(_component_dialog_shell, {
      title: _ctx.titles[_ctx.operaType],
      footerType: "customize",
      onClose: _cache[14] || (_cache[14] = ($event: any) => (_ctx.$emit('close'))),
      onSubmit: _ctx.submit
    }, {
      footer: _withId(() => [
        _createVNode("span", _hoisted_3, [
          (_ctx.operaType=='edit')
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 0,
                style: {"float":"left"},
                onClick: _ctx.editFeaturePlan
              }, {
                default: _withId(() => [
                  _createTextVNode(_toDisplayString(_ctx.$wordList.ProperAllTextEditFeaturePlan), 1)
                ]),
                _: 1
              }, 8, ["onClick"]))
            : _createCommentVNode("", true),
          (_ctx.operaType == 'edit')
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 1,
                onClick: _ctx.resetPw,
                type: "primary"
              }, {
                default: _withId(() => [
                  _createTextVNode(_toDisplayString(_ctx.$wordList.TabelResetPwTitle), 1)
                ]),
                _: 1
              }, 8, ["onClick"]))
            : _createCommentVNode("", true),
          _createVNode(_component_el_button, {
            onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.$emit('close')))
          }, {
            default: _withId(() => [
              _createTextVNode(_toDisplayString(_ctx.$wordList.TabelFootCancel), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _ctx.submit
          }, {
            default: _withId(() => [
              _createTextVNode(_toDisplayString(_ctx.$wordList.TabelFootSubmit), 1)
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      default: _withId(() => [
        _createVNode(_component_el_form, {
          ref: "formRef",
          "label-position": _ctx.$formLabelPosition,
          model: _ctx.formData,
          rules: _ctx.rules
        }, {
          default: _withId(() => [
            _createVNode(_component_el_form_item, {
              label: _ctx.$wordList.TabelResetPwInHtmlAccount,
              prop: "Account"
            }, {
              default: _withId(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.formData.Account,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.formData.Account = $event)),
                  disabled: _ctx.operaType=='edit'?true:false
                }, null, 8, ["modelValue", "disabled"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _ctx.$wordList.TabelUserInHtmlCompany
            }, {
              default: _withId(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.formData.Community,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.formData.Community = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _ctx.$wordList.TabelPropertyManageEmail,
              prop: "Email"
            }, {
              default: _withId(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.formData.Email,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.formData.Email = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _ctx.$wordList.ProperAllTextMobileNumber
            }, {
              default: _withId(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.formData.Phone,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.formData.Phone = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _ctx.$wordList.TabelCommunitiesTimeZone
            }, {
              default: _withId(() => [
                _createVNode(_component_cus_select, {
                  modelValue: _ctx.formData.TimeZone,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.formData.TimeZone = $event)),
                  filter: ""
                }, {
                  default: _withId(() => [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.timeZoneOptions, (tiemZoneItem) => {
                      return (_openBlock(), _createBlock(_component_cus_option, {
                        key: tiemZoneItem,
                        label: tiemZoneItem.label,
                        value: tiemZoneItem.value
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            (_ctx.operaType === 'add')
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 0,
                  label: _ctx.$wordList.ProperAllTextLanguage
                }, {
                  default: _withId(() => [
                    _createVNode(_component_cus_select, {
                      modelValue: _ctx.formData.Language,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.formData.Language = $event))
                    }, {
                      default: _withId(() => [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.langOptions, (langItem) => {
                          return (_openBlock(), _createBlock(_component_cus_option, {
                            key: langItem,
                            label: langItem.label,
                            value: langItem.value
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label"]))
              : _createCommentVNode("", true),
            _createVNode(_component_el_form_item, {
              label: _ctx.$wordList.ProperAllTextPayDistributor
            }, {
              default: _withId(() => [
                _createVNode(_component_el_switch, {
                  modelValue: _ctx.formData.ChargeMode,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.formData.ChargeMode = $event)),
                  "active-color": "#13ce66",
                  "inactive-color": "#DCDFE6",
                  "active-value": "1",
                  "inactive-value": "0",
                  "active-text": _ctx.$wordList.ProperAllTextOn,
                  "inactive-text": _ctx.$wordList.ProperAllTextOff
                }, null, 8, ["modelValue", "active-text", "inactive-text"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _ctx.$wordList.ProperAllTextPropertyTerminalPasswordEncryption
            }, {
              default: _withId(() => [
                _createVNode(_component_el_switch, {
                  modelValue: _ctx.formData.IsEncryptPin,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.formData.IsEncryptPin = $event)),
                  "active-color": "#13ce66",
                  "inactive-color": "#DCDFE6",
                  "active-value": "1",
                  "inactive-value": "0",
                  "active-text": _ctx.$wordList.ProperAllTextOn,
                  "inactive-text": _ctx.$wordList.ProperAllTextOff
                }, null, 8, ["modelValue", "active-text", "inactive-text"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _ctx.$wordList.ProperAllTextDisMonitor
            }, {
              default: _withId(() => [
                _createVNode(_component_el_radio, {
                  modelValue: _ctx.formData.IsVillaMonitor,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.formData.IsVillaMonitor = $event)),
                  label: "1"
                }, {
                  default: _withId(() => [
                    _createTextVNode(_toDisplayString(_ctx.$wordList.ProperAllTextOn), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_el_radio, {
                  modelValue: _ctx.formData.IsVillaMonitor,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.formData.IsVillaMonitor = $event)),
                  label: "0"
                }, {
                  default: _withId(() => [
                    _createTextVNode(_toDisplayString(_ctx.$wordList.ProperAllTextOff), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, null, {
              default: _withId(() => [
                _createVNode("label", null, _toDisplayString(_ctx.$wordList.ProperAllTextComFeaturePlan), 1),
                (_ctx.communityFeatureData.Plan.length < 10)
                  ? (_openBlock(), _createBlock("i", {
                      key: 0,
                      class: "modify-icon el-icon-my-add margin-left15px",
                      onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.updatePlan++))
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_feature_plan_select, {
                  "select-item": _ctx.communityFeatureData,
                  options: _ctx.communityFeatureOptions,
                  update: _ctx.updatePlan,
                  editFee: _ctx.isEditFee
                }, null, 8, ["select-item", "options", "update", "editFee"]),
                (_ctx.showComFeatureTips)
                  ? (_openBlock(), _createBlock("label", _hoisted_1, _toDisplayString(_ctx.$wordList.RuleCommonLabelEmpty2.format(_ctx.$wordList.ProperAllTextFeaturePlan)), 1))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, null, {
              default: _withId(() => [
                _createVNode("label", null, _toDisplayString(_ctx.$wordList.ProperAllTextOfficeFeaturePlan), 1),
                (_ctx.officeFeatureData.Plan.length < 10)
                  ? (_openBlock(), _createBlock("i", {
                      key: 0,
                      class: "modify-icon el-icon-my-add margin-left15px",
                      onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.updateOfficePlan++))
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_feature_plan_select, {
                  "select-item": _ctx.officeFeatureData,
                  options: _ctx.officeFeatureOptions,
                  update: _ctx.updateOfficePlan,
                  editFee: _ctx.isEditFee
                }, null, 8, ["select-item", "options", "update", "editFee"]),
                (_ctx.showOfficeFeatureTips)
                  ? (_openBlock(), _createBlock("label", _hoisted_2, _toDisplayString(_ctx.$wordList.RuleCommonLabelEmpty2.format(_ctx.$wordList.ProperAllTextFeaturePlan)), 1))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["label-position", "model", "rules"])
      ]),
      _: 1
    }, 8, ["title", "onSubmit"]),
    (_ctx.showList)
      ? (_openBlock(), _createBlock(_component_update_billing_list, {
          key: 0,
          operateType: "featurePlan",
          initData: _ctx.initData,
          onClose: _cache[15] || (_cache[15] = ($event: any) => (_ctx.showList=false)),
          onSubmit: _ctx.confirmUpdate
        }, null, 8, ["initData", "onSubmit"]))
      : _createCommentVNode("", true),
    (_ctx.showEditPlanDialog)
      ? (_openBlock(), _createBlock(_component_edit_feature_plan_dialog, {
          key: 1,
          onClose: _cache[16] || (_cache[16] = ($event: any) => (_ctx.showEditPlanDialog=false)),
          onSuccess: _cache[17] || (_cache[17] = ($event: any) => (_ctx.isEditFee=true))
        }))
      : _createCommentVNode("", true)
  ]))
})